import { observer } from 'mobx-react-lite'
import i from '../../translations/i'
import { Titles } from '../../layouts/Titles'
import __catalog from './__catalog'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Alert, Button, notification } from 'antd'
import { storeLocal, storeSession } from '../../helpers/stores'
import { CategoryTable } from '../../components/category_table/CategoryTable'
import { CategoryTableController } from '../../components/category_table/category_table.controller'
import { CATEGORY_CREATED_NOTICE } from '../../modules/shop/catalog/controllers/category.controller'

// Каталог: категории уровня; категория с подкатегориями открывает их, без — свои товары (CatalogProductList)
export const CatalogList = observer(() => {

    const { categoryID = 0 }: any = useParams()

    const [table] = useState(() => new CategoryTableController({
        parentId: Number(categoryID),
        onLoaded: result => __catalog.setMeta(result),
    }))

    const role = Number(storeLocal.get('role'))

    // Сюда переходят после создания категории (category.controller) — сообщаем, что она создана
    useEffect(() => {
        const created = storeSession.get(CATEGORY_CREATED_NOTICE)
        if (created === undefined) return

        storeSession.remove(CATEGORY_CREATED_NOTICE)
        notification.success({ message: i.t('categories:created'), description: created || undefined })
    }, [])

    return(
        <>
            <Titles
                title={i.t('categories:catalog')}
                breadcrumb={__catalog.tree}
                buttons={[
                    { title: i.t('categories:createCategory'), href: `/shop/catalog/category/create/${categoryID}`, type: 'dashed', disabled: role === 4 },
                    { title: i.t('categories:createProduct'), href: `/shop/catalog/product/0/${categoryID}`, type: 'dashed' },
                    { title: i.t('categories:prices'), href: `/shop/mass`, type: 'dashed', disabled: role === 4 }
                ]}
            />

            {(__catalog.productWithoutCategory > 0 && role !== 4) &&
                <Alert
                    className="pt-alert"
                    message={`${i.t('categories:without')}: ${__catalog.productWithoutCategory}`}
                    type="info"
                    action={<Button size="small" type="primary" href="/shop/without">{i.t('categories:withoutList')}</Button>}
                    closable
                />
            }

            <CategoryTable table={table} createHref={`/shop/catalog/category/create/${categoryID}`} />
        </>
    )
})
